import { Form, Text } from 'react-form';
import { AbconetApi } from '../General/AbconetApi';
var Select = require('../General/Selectors/FormSelector').FormSelector;
const statesOptions = [
    { value: 'ACT', label: 'ACT' },
    { value: 'NSW', label: 'NSW' },
    { value: 'NT', label: 'NT' },
    { value: 'QLD', label: 'QLD' },
    { value: 'SA', label: 'SA' },
    { value: 'TAS', label: 'TAS' },
    { value: 'VIC', label: 'VIC' },
    { value: 'WA', label: 'WA' },
];

const requiredValidate = (fieldName, text) => {
    var returnText = !text || text.trim() === '' ? `${fieldName} is a required field.` : null;
    return returnText;
}
const emailValidate = email => {
    if (!email || email.trim() === '') {
        return "Email is a required field.";
    };

    if (validateEmail(email)) {
        return null;
    }

    return "A valid email is required.";
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


const confirmPasswordValidate = (formApi, text) => {
    var formState = formApi.getFormState();

    if (formState.values['confirmPassword'] !== formState.values['password']) {
        return 'Confirm password must match password.';
    }

    return null;
}

const passwordValidate = (text) => {
    if (!text) {
        return "A password is required.";
    };

    // Validate lowercase letters
    var lowerCaseLetters = /[a-z]/g;
    var isValid = true;
    if (!text.match(lowerCaseLetters)) {
        isValid = false;
    } 

    // Validate capital letters
    var upperCaseLetters = /[A-Z]/g;
    if (!text.match(upperCaseLetters)) {
        isValid = false;
    } 

    var numbers = /[0-9]/g;
    if (!text.match(numbers)) {
        isValid = false;
    } 

    // Validate length
    if (text.length < 8) {
        isValid = false;
    }

    if (!isValid) {
        return "Your password must have at least 1 uppercase, 1 lowercase, a number and be at least 8 characters in length.";
    }

    return null;
}




export class RegisterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaved: true,
            step: 0
        }
    }

    setChange() {
        this.setState({ isSaved: false });
    }

    setStep(type) {
        this.setState({
            step: type
        });
    }

    getFieldClass(field) {

        var formState = this.formApi.getFormState();

        if (formState.submits === 0) {
            return "form-control";
        }

        var className = "form-control";
        if (formState.errors && formState.errors[field]) {
            className += " is-invalid";
        }

        return className;
    }

    renderError(field) {
        var formState = this.formApi.getFormState();
        if (formState.errors && formState.errors[field]) {
            return <div className="invalid-feedback">{formState.errors[field]}</div>;
        }

        return null;
    }

    renderSaveButton() {
        if (this.state.success === true) {
            return;
        }
        var btnText = 'Register';
        var btnClass = 'changes';

        if (this.state.isSaving) {
            btnText = 'Registering';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    renderStep0() {
        var loginNowLink = '/login/';

        var redirectUrl = getUrlParameter('redirect');
        if (redirectUrl) {
            loginNowLink += '?redirect=' + redirectUrl;
        }

            return <Form
                   onChange={this.setChange.bind(this)}
                  defaultValues={this.state.submittedValues}>
                   {formApi => {
                       this.formApi = formApi;
                       return (
                           <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                               <div className="card card-body bg-light">
                                   <h4>Are you an existing Abco customer?</h4>

                                   <div className="row justify-content-around">
                                       <div className="option-container col-md-6">
                                           <div className="intro-text">My company has ordered from Abco before and want to order online</div>
                                           <button className="lg-icon-button" onClick={this.setStep.bind(this, 'existing')}>
                                               <i className="icon icon-existing-customer"></i>
                                               <div>Existing Abco Customer</div>
                                            </button>
                                       </div>

                                       <div className="option-container col-md-6 align-self-end">
                                           <div className="intro-text">My company has never ordered from Abco and I want to start.</div>
                                           <button className="lg-icon-button" onClick={this.setStep.bind(this, 'new')}>
                                               <i className="icon icon-new-customer"></i>
                                               <div>New Customer</div>
                                           </button>
                                       </div>
                                   </div>

                               </div>
                               <p>Already have an account? <a href={loginNowLink}>Login now</a></p>
                           </form>
                       )
                   }}
               </Form>;
    }

    renderStepNew() {
        return <Form
                   onChange={this.setChange.bind(this)}
                   onSubmit={this.submitNew.bind(this)} defaultValues={this.state.submittedValues}>
                   {formApi => {
                       this.formApi = formApi;
                       return (
                           <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                               <div className="card card-body bg-light">
                                   <div className="form-row">
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-company-name">Company Name:</label>
                                           <Text field="companyName" id="dynamic-company-name" className={this.getFieldClass('companyName')} validate={requiredValidate.bind(this, "Company Name")} maxLength="80" />
                                           {this.renderError('companyName')}
                                       </div>
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-company-abn">ABN (optional):</label>
                                           <Text field="abn" id="dynamic-company-abn" className="form-control" maxLength="30" />
                                           {this.renderError('abn')}
                                       </div>
                                   </div>

                                   <div className="form-row">
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-firstname">First Name:</label>
                                           <Text field="firstName" id="dynamic-firstname" className={this.getFieldClass('firstName')} validate={requiredValidate.bind(this, "firstName")}/>
                                           {this.renderError('firstName')}
                                       </div>
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-lastname">Last Name:</label>
                                           <Text field="lastName" id="dynamic-lastname" className={this.getFieldClass('lastName')} validate={requiredValidate.bind(this, "lastName")} />
                                           {this.renderError('lastName')}
                                       </div>
                                   </div>

                                   <div className="form-row">
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-number">Phone Number:</label>
                                           <Text field="phone" id="dynamic-number" className={this.getFieldClass('phone')} validate={requiredValidate.bind(this, "Phone number")}/>
                                           {this.renderError('phone')}
                                       </div>
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-number">State:</label>
                                           <Select field="state" options={statesOptions} className={this.getFieldClass('state')} validate={requiredValidate.bind(this, "State")} />
                                           {this.renderError('state')}
                                       </div>
                                   </div>

                                   <hr />

                                   <div className="form-row">
                                       <div className="form-group col-md-12">
                                           <label htmlFor="dynamic-email">Email:</label>
                                           <Text type="email" field="email" id="dynamic-email" className={this.getFieldClass('email')} validate={emailValidate} />
                                           {this.renderError('email')}
                                       </div>
                                   </div>


                                   <div className="form-row">
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-password">Password:</label>
                                           <Text type="password" field="password" id="dynamic-password" className={this.getFieldClass('password')} validate={passwordValidate} />
                                           {this.renderError('password')}
                                       </div>

                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-confirmPassword">Confirm Password:</label>
                                           <Text type="password" field="confirmPassword" id="dynamic-confirmPassword" className={this.getFieldClass('confirmPassword')} validate={confirmPasswordValidate.bind(this, formApi)} onChange={this.setChange.bind(this)} />
                                           {this.renderError('confirmPassword')}
                                       </div>
                                   </div>

                                   <div className="row">
                                       <div className="col-6">
                                           <button className="btn btn-outline-primary" onClick={this.setStep.bind(this, 0)}>Back</button>
                                       </div>
                                       <div className="col-6">
                                           {this.renderSaveButton()}
                                       </div>
                                   </div>
                               </div>
                           </form>
                       )
                   }}
               </Form>
    }

    renderStepExisting() {
        return <Form
                   onChange={this.setChange.bind(this)}
                   onSubmit={this.submitExisting.bind(this)} defaultValues={this.state.submittedValues}>
                   {formApi => {
                       this.formApi = formApi;
                       return (
                           <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                               <div className="card card-body bg-light">
                                   <div className="form-row">
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-company-name">Company Name:</label>
                                           <Text field="companyName" id="dynamic-company-name" validate={requiredValidate.bind(this, "Company Name")} className={this.getFieldClass('companyName')}/>
                                           {this.renderError('companyName')}
                                       </div>
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-company-accno">Account Number:</label>
                                           <Text field="accno" id="dynamic-company-accno" className={this.getFieldClass('accno')} validate={requiredValidate.bind(this, "Account Number")} />
                                           {this.renderError('accno')}
                                       </div>
                                   </div>

                                   <div className="form-row">
                                       <div className="form-group col-md-12">
                                           <label htmlFor="dynamic-name">Name:</label>
                                           <Text field="name" id="dynamic-name" className={this.getFieldClass('name')} validate={requiredValidate.bind(this, "Name")} />
                                           {this.renderError('name')}
                                       </div>
                                   </div>

                                   <div className="form-row">
                                       <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-email">Email:</label>
                                           <Text type="email" field="email" id="dynamic-email" className={this.getFieldClass('email')} validate={emailValidate} />
                                           {this.renderError('email')}
                                       </div>
                                           <div className="form-group col-md-6">
                                           <label htmlFor="dynamic-phone">Phone Number:</label>
                                           <Text field="phone" id="dynamic-phone" className={this.getFieldClass('phone')} validate={requiredValidate.bind(this, "Phone Number")} /> 
                                           {this.renderError('phone')}
                                       </div>
                                   </div>

                                   <div className="row">
                                       <div className="col-6">
                                           <button className="btn btn-outline-primary" onClick={this.setStep.bind(this, 0)}>Back</button>
                                       </div>
                                       <div className="col-6">
                                           {this.renderSaveButton()}
                                       </div>
                                   </div>
                               </div>
                           </form>
                       )
                   }}
               </Form>
    }

    renderUserCreated() {
        return <div className="card card-body bg-light">
            <h4>Your user has been created.</h4>
            You are being logged in.
            <br />
            <br />
            <br />
            <div className="loader-container"><div className="loader"></div></div>
               </div>;
    }

    renderExistingUserCreated() {
        return <div className="card card-body bg-light">
            <h4>A request has been sent.</h4>
        We will be in contact with the details of your account.

            </div>;
    }

    showStep() {
        switch (this.state.step) {
            

            case 0:
            case 'existing':
            case 'new':
                return this.renderStepNew();
                break;

            case 'userCreated':
                return this.renderUserCreated();
                break;
            case 'existingUserCreated':
                return this.renderExistingUserCreated();
                break;
        }

        return <div>Incorrect step</div>;
    }

    submitNew(submittedValues) {
        this.setState({ isSaving: true });
        AbconetApi.post('/api/user/registerNew/', submittedValues).then(result => {
            this.setState({ isSaved: true, isSaving: false });
            if (!result.message) {
                this.setState({ step: 'userCreated' });

                dataLayer.push({
                    'event': 'UserRegister'
                });


                AbconetApi.post(`/api/user/login`, { username: submittedValues.email, password: submittedValues.password, staySignedIn: false }).then((data) => {
                    if (data.success) {
                        var redirectUrl = getUrlParameter('redirect');
                        if (redirectUrl != null) {
                            window.location.href = '/' + redirectUrl.substring(1);
                        } else {
                            window.location = '/';
                        }
                    }
                    else {
                        this.setState({ errorMessage: data.msg, isLoading: false });
                    }
                });
            }
        }).catch((error) => {
            this.setState({
                isSaved: true,
                isSaving: false,
            });
        });;
    }

    submitExisting(submittedValues) {
        this.setState({ isSaving: true });
        AbconetApi.post('/api/user/registerExisting/', submittedValues).then(result => {
            this.setState({ isSaved: true, isSaving: false });
            if (!result.message) {
                this.setState({ step: 'existingUserCreated' });
            }
        });
    }

    render() {
        return <div className="register-form">
            <h1>Register for Abconet</h1>
            {this.showStep()}
        </div>;
    }
}